import { UtilitiesService } from '@app/shared/services/utilities.service';
import { Component, OnInit } from '@angular/core';
import { FirebaseService } from '@app/shared/services/firebase.service';
import { DocumentReference } from 'firebase/firestore';
const COLLECTION_NAME = 'advertising';
const TEXT_FIELD = 'content';
import { Logger } from '@app/core';
const log = new Logger('HomeComponent');

// import * as cpsInfo from './cps.json';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  quote: string | undefined;
  isLoading = false;
  docs: any[] = [];

  constructor(private firebaseSvc: FirebaseService, private utilities: UtilitiesService) { }

  ngOnInit() { }

  async exportData() {
    try {
      const RESP = await this.firebaseSvc.afs.collection('sub-specialties').ref.get();

      const array: any[] = RESP.docs.map(doc => {
        const data: any = doc.data();
        return {
          id: doc.id
        }
      });

      let batch = this.firebaseSvc.afs.firestore.batch();
      for (const item of array) {
        var ref = this.firebaseSvc.afs.collection('sub-specialties').doc(item.id).ref;
        batch.update(ref, { date: new Date(), modified: new Date() });
      }
      await batch.commit();



    } catch (error) {
      log.debug('error', error);
    }
  }

  async uploadZips() {
    /*for await (const cp of cpsInfo.rows) {
      const elem = {
        postal_code: cp.postal_code,
        city: cp.city,
        colony: cp.colony,
        state: cp.state
      };
      log.debug(cp.postal_code, cp.colony, cp.city, cp.state);
      const elemState = {
        city: cp.city,
        state: cp.state
      };
      // create elements in db
      await this.firebaseSvc.saveState(elemState, elem);
      await this.firebaseSvc.saveCP(elem);
    }*/
  }

  async getItems() {
    try {
      const RESP = await this.firebaseSvc.afs.collection(COLLECTION_NAME).ref.get();
      this.docs = RESP.docs.map(doc => {
        const title: string = doc.get(TEXT_FIELD) || undefined;
        const id = doc.id;
        const search: string[] = this.utilities.arraySearch(title);
        return { id, title, search };
      }).filter(doc => doc.title);
      log.debug(`=== DOCS(${COLLECTION_NAME}) ===`, this.docs);
    } catch (error) {
      log.debug('error', error);
    }
  }

  async setItems() {
    try {
      for (let item of this.docs) {
        await this.firebaseSvc.afs.collection(COLLECTION_NAME).doc(item.id).update({ search: item.search });
      }
      log.debug('=== ¡UPDATED! ===');
    } catch (error) {
      log.debug('error', error);
    }
  }
}
